module.exports = __webpack_public_path__ + "static/feature3Desktop-9fd7c3220090bb7269a41a71564e4842.png";